<template>
  <CFooter :fixed="false">
    <div>
      <a href="http://teccommerce.com.br:8081" target="_blank">SysPed</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} creativeLabs.</span>
    </div>
    <div class="mfs-auto">
      <span class="mr-1" target="_blank">Desenvolvido por</span>
      <a href="http://teccommerce.com.br">TecCommerce</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
